import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import AboutThisProject from "./AboutThisProject";

function Layout() {
  return (
    <>
      <AboutThisProject />
      <div className="h-100">
        <NavBar />
        <main className="mt-5 position-relative flex-grow-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default Layout;
